import { render, staticRenderFns } from "./TransferTippaniPrint.vue?vue&type=template&id=c5abcdae&scoped=true&"
import script from "./TransferTippaniPrint.vue?vue&type=script&lang=js&"
export * from "./TransferTippaniPrint.vue?vue&type=script&lang=js&"
import style0 from "./TransferTippaniPrint.vue?vue&type=style&index=0&id=c5abcdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5abcdae",
  null
  
)

export default component.exports